// Layout tokens shared by Page and NavBar (kept out of the .tsx so Fast Refresh works).

/**
 * Width policy for a page's content column.
 * - full:    data tables (RFQs, databases, quote history, blacklist). Fluid,
 *            capped at 2400px so ultra-wide screens don't stretch rows absurdly.
 * - wide:    dashboards (analytics, tracking). Capped at 1800px, centred.
 * - reading: forms and prose. Capped at 1200px, centred.
 */
export type PageWidth = "full" | "wide" | "reading";

export const PAGE_MAX_WIDTH: Record<PageWidth, number> = {
  full: 2400,
  wide: 1800,
  reading: 1200,
};

/** Horizontal page gutters: 16px phone, 24px tablet/laptop, 32px large screens. */
export const PAGE_GUTTER_X = { xs: 2, sm: 3, xl: 4 } as const;
